module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAOBJREFUOI3F0TFOAkEYxfH/N5BgxRko4AySaMJug7tYQuIJLAwXwNhLQ2iNBQdAduhIsCDYcQFLCq9hsTM2LAlxgZlteNU0v5eXb+ASCWad6+ytfHE4jx8Fuwl1NAIQX0zKOypzduy84B82WCxbpwW5WGx/3Vu+7Re0pu26L4bdEYMkekGVvgN9d++DASRM4meEVwBj+BVlul/dz4ULBihboZodQikqxigdJvGElKdzGHbfGOh4KDDIveAJDFAC+PnYrmoPjSuBWx+8L8gtccAHBQclhhsXfDQtHTULwSL5A1bQd3cpUSUSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./assets/success.png
// module id = 7
// module chunks = 0